module.exports = __webpack_public_path__ + "static/media/monitor.b2656584.svg";